import { type ApiConfig, configure } from './apiInstance';
import { getQuestions } from './questionnaire';

/** Returns a list of attached question global id's, if any */
export async function getAttachedQuestionIds(
  questionnaireId: string,
  config: ApiConfig,
): Promise<string[]> {
  configure(config);

  const response = await getQuestions(questionnaireId);

  return response
    .map((x) => x.globalId)
    .filter<string>(
      (globalId): globalId is string => typeof globalId === 'string',
    );
}
